// "Dela Cruz, Juan P." from a row with lname / fname / mname.
export function fullName(person) {
  if (!person) return '';
  const base = [person.lname, person.fname].filter(Boolean).join(', ');
  return person.mname ? `${base} ${person.mname[0]}.` : base;
}

const blankName = (v) => ['', 'n/a'].includes(String(v ?? '').trim().toLowerCase());

// "Dela Cruz, Juan Jr., Santos": last, first (with suffix), middle, as the
// DepEd forms list learners. Names are title-cased; a suffix (Jr., III)
// stays as entered.
export function surnameFirst(person) {
  if (!person) return '';
  const title = (v) => String(v ?? '').trim().toLowerCase().replace(/(^|[\s'-])\S/g, (c) => c.toUpperCase());
  const suffix = blankName(person.suffix) ? '' : String(person.suffix).trim();
  const first = [title(person.fname), suffix].filter(Boolean).join(' ');
  return [title(person.lname), first, blankName(person.mname) ? '' : title(person.mname)].filter(Boolean).join(', ');
}

// Learners grouped by sex (Male first, as on DepEd forms), each group
// sorted by surname, then first and middle name: [{ sex, rows }]. Rows
// without a sex go last.
export function groupBySex(rows) {
  const compare = (x, y) => String(x ?? '').localeCompare(String(y ?? ''), undefined, { sensitivity: 'base' });
  const byName = (a, b) => compare(a.lname, b.lname) || compare(a.fname, b.fname) || compare(a.mname, b.mname);
  const groups = new Map([['Male', []], ['Female', []]]);
  for (const row of rows) {
    const sex = ['Male', 'Female'].includes(row.sex) ? row.sex : 'Not set';
    if (!groups.has(sex)) groups.set(sex, []);
    groups.get(sex).push(row);
  }
  return [...groups]
    .filter(([, list]) => list.length)
    .map(([sex, list]) => ({
      sex,
      rows: [...list].sort(byName),
    }));
}
